import DraggableModal from '../../layout/DraggableModal/DraggableModal';
import React from 'react';
import { useTranslation } from "react-i18next";

const AddPassiveModal = ({ isOpen, onClose, onSubmit, formData, setFormData }) => {

  const { t } = useTranslation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };

    return isOpen && (
      <DraggableModal headerText={t("sheet.passives")} isVisible={isOpen} onClose={onClose}>
        <form onSubmit={handleSubmit}>
          <label>
            {t("sheet.passiveName")}
            <input required type="text" name="name" value={formData.name} onChange={handleChange} />
          </label>
          <label>
            {t("sheet.passiveDescription")}
            <textarea name="description" value={formData.description} onChange={handleChange} />
          </label>
          <button type="submit">{t("sheet.addPassive")}</button>
        </form>
      </DraggableModal>
    )
  };
export default AddPassiveModal;
